module.exports = __webpack_public_path__ + "img/img_charge_img3.68a2d440.png";